export default __webpack_public_path__ + "static/media/granville29.cf644e60.jpg";